import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import type { ExternalReference } from '@ilteducation/exercise-service-types';

type Props = {
  index: number;
  parentSource: string;
  resource: string;
  item: ExternalReference;
  preview: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalReference',
  props: {
    index: null,
    parentSource: null,
    resource: null,
    item: null,
    preview: { type: Boolean }
  },
  setup(__props: any) {



// TODO: Implement visibility handling
const visibility = ref<string[]>([]);

const availableVisibility = [
  { value: 'student', text: 'Student' },
  { value: 'guardian', text: 'Guardian' },
  { value: 'employee', text: 'Employee' },
];


return { __sfc: true,visibility, availableVisibility }
}

})